export default __webpack_public_path__ + "static/media/menu.ad1e383a.svg";